const messages = {
  bonus: {
    title: "Premijų kreditų apžvalga",
    description: "Premijos eurais skiriamos dalyvaujančioms įmonėms pagal pateiktus pardavimo duomenis.",
    lastMonth: "Praėjęs mėnuo",
    currentMonth: "Einamasis mėnuo",
    totalCurrentYear: "Iš viso einamaisiais metais",
    totalLastYear: "Iš viso praėjusiais metais",
  },
  points: {
    title: "Taškų kreditų apžvalga",
    period: "Einamieji kalendoriniai metai ({year})",
    totalAwarded: "Iš viso suteikta taškų",
    redeemed: "Panaudoti taškai",
    totalBalance: "Bendras taškų balansas",
    redemptionRate: "Panaudoti taškai kaip suteiktų taškų procentas",
    averageAwarded: "Vidutiniškai suteikta taškų vienai nupirktai padangai",
    standardAwarded: "Grynieji taškai iš apskaičiuotų pardavimo eilučių, įskaitant grąžinimus",
    bsPlusInclBooster: "Taškai iš pardavimo eilučių su teigiamu kiekiu",
    perTire: "Panaudoti taškai vienai nupirktai padangai",
  },
  tires: {
    title: "Padangų kiekio apžvalga",
    description: "Klientų įsigytos padangos",
    prevMonth: "Praėjęs mėnuo",
    totalLastYear: "Iš viso praėjusiais metais",
    purchaseIndirect: "Pirkimas per didmenininką (netiesioginis)",
    purchaseDirect: "Pirkimas per didmenininką (tiesioginis)",
    totalCurrentYear: "Iš viso einamaisiais metais",
    currentMonth: "Einamasis mėnuo",
  },
  participating: {
    title: "Dalyvaujančių klientų apžvalga",
    description: "Įmonės, kurios registruojasi BRIDGESTONE PLUS, gali būti susietos pagal kliento numerį.",
    total: "Iš viso",
    newThisMonth: "Nauji šį mėnesį",
    newThisYear: "Nauji šiais metais",
    createdInCurrentMonth: "Sukurta einamąjį mėnesį (administratoriaus)",
    loginsCurrentYear: "Prisijungimai einamaisiais metais (po sąlygų patvirtinimo)",
  },
  brand: {
    title: "Prekės ženklas",
    description: "Jūsų pirkimai išsamiai",
    centerTitle: "Pagal\nprekės ženklą",
  },
  rim: {
    title: "Ratlankis",
    centerTitle: "Pagal ratlankio\nmatmenį",
  },
  tireGoals: {
    title: "Padangų tikslai",
    subtitle: "Gaukite taškų už padangų pirkimus.",
    centerTitle: "Pagal padangos\nmatmenį",
    tiresRemaining: "Likę padangos",
    progressionTarget: "Pažangos tikslas: ",
    pointsEarnedPurchases: "taškai, uždirbti\n" + "už jūsų\n" + "pirkimus",
    pointsEarnedBoosters: "taškai, uždirbti\n" + "iš\n" + "boosterių",
    purchasesDetail: "Jūsų pirkimai išsamiai",
    cta: "Sužinokite daugiau apie savo taškus",
    pointsTitle: "Jūsų taškai",
    pointsSubtitle: "Taškai, gauti už Bridgestone pirkimus",
    achievementsTitle: "Jūsų pasiekimai",
    achievementsSubtitle: "Jūsų metinis įsipareigojimas:",
    achievementsSubtitle2: "padangų",
  },
  score: {
    title: "Rezultatas",
    total: "Iš viso",
    credits: "Kreditai",
    deductions: "Nuskaitymai",
        unlockedPoints: "Atrakinti taškai",
        pendingPoints: "Laukiantys taškai",
  },
  score_extended: {
    title1: "Taškų balansas",
    title2: "Premija eurais",
    balance: "Taškų balansas",
    bonus_in_euro: "Premija eurais",
    date: "Data",
    added_points: "Pridėti taškai",
    total_bands: "Iš viso prekės ženklų",
    goal: "Tikslas",
    tyres_previous_year: "Praėjusiais metais parduotos padangos",
    tyres_current_year: "Šiais metais parduotos padangos",
    target_this_year: "Šių metų pardavimo tikslas",
    bonus_this_year: "Uždirbta premija (€)",
    loyal_minimum: "Minimalus lojalumo lygis",
    bonus_multiplier: "Premijos daugiklis",
  },
  lastImport: {
    label: "Paskutinis pardavimo duomenų importas:",
    on: "",
  },
  wholesalerTable: {
    title: "Dalyvaujantys klientai išsamiai",
    description: "Žemiau rasite įmones, kurios užsiregistravo BRIDGESTONE PLUS naudodamos jūsų įmonės kliento numerį. Galite naudoti filtrus rikiavimui arba paiešką klientams surasti.",
    columns: {
      customer_number: "Kliento nr.",
      address_company_name: "Įmonė",
      address_street: "Gatvė ir namo nr.",
      address_postal_code: "Pašto kodas",
      address_city: "Miestas",
      last_registration: "Paskutinė registracija",
      network: "Tinklas",
      profile_group: "Grupė",
      tires_amount: "Padangų kiekis",
      point_balance: "Taškų balansas",
      bonus: "Premija",
      details: "Detalės",
    },
    searchPlaceholder: "Paieška",
  },
  dealerTable: {
    columns: {
      date: "Data",
      wholesaler_bs_plus: "Didmenininkas BS+",
      customer_number: "Kliento numeris",
      article: "Straipsnis",
      brand: "Prekės ženklas",
      product: "Produktas",
      type: "Tipas",
      inch: "Coliai",
      season: "Sezonas",
      amount: "Kiekis",
      points: "Taškai",
      activity: "Veikla",
      total_points: "Iš viso taškų",
    },
    title: "Dealerių lentelė",
    description: "Dealerių veiklos apžvalga",
  },
  business_units: {
    title: "Verslo vienetai",
    centerTitle: "Pagal\nvienetą",
  },
  season: {
    title: "Sezonas",
    centerTitle: "Pagal metų\nlaiką",
  },
};

export default {
  messages,
};
